import React, { useEffect, useState } from 'react'

const ColorPanel = ({data, className = '', wrapFirstRow = false, multiSelect = false, handleFilterChange}) => {
  
  const [printed ] = useState(data)
  const [colorSelected, setColorSelected] = useState('')

  const handlePaletteSelect = (palette) => {
    setColorSelected(palette)
    handleFilterChange("colour", palette, true)
  }

  return (
    <React.Fragment>
      <section className={`my-5`} aria-label='filter-colors'>
        <div className={`flex ${wrapFirstRow && 'flex-wrap-reverse'}  justify-between items-center`}>
          <div className="flex flex-nowrap gap-x-1">
            <span className="text-sm font-semibold">COLOR:</span>
            <span className="text-sm font-normal">{colorSelected?.name}</span>
          </div>
        </div>
        <div className="flex flex-1 flex-wrap gap-2 mt-3">
        {
            printed?.map((item, index) => {
                return (
                  <div
                  className={`${item.className === 'bg-[#FFFFFF]' && colorSelected !== item ? 'border-[#ccc] border-solid border-[1px]' : ''} circle-8 overflow-hidden cursor-pointer ${item.className} ${colorSelected === item ? 'border-2 border-black opacity-100' : 'border-1 opacity-50'}`}
                    key={`color-${item.name}-${index}`}
                    onClick={() => handlePaletteSelect(item)}
                    aria-label={`filter-color-${item?.name}`}
                  ><img src={item?.image} alt={item?.name} /></div>
                )
            })
          }

        </div>
      </section>
    </React.Fragment>
  );
}

export default ColorPanel